import React from "react";
import { View, Text, Image, TouchableOpacity } from "react-native";
import { Edit } from "lucide-react-native";
import { RestaurantMenu } from "../../types/restaurant.types";
import { menuScreenStyles as styles } from "../../styles/styles";
import { FlickOColors } from "../../styles/color";
import { RatingInfo, Ratings } from "../../component/RatingInfo";
import { config } from "../../../../config";
import { cs } from "../../constant";

interface RestaurantProfileProps {
  restData: RestaurantMenu;
  ratings: Ratings;
  onEditPress: () => void;
}

export const RestaurantProfile: React.FC<RestaurantProfileProps> = ({
  restData,
  ratings,
  onEditPress,
}) => {
  return (
    <View style={styles.profileSection}>
      <View style={styles.imageContainer}>
        <Image
          source={require("../../../../../assets/restaurant-example.jpg")}
          style={styles.profileImage}
        />
        {config.app.name === cs.partnerApp && (
          <TouchableOpacity style={styles.editButton} onPress={onEditPress}>
            <Edit size={24} color={FlickOColors.white} />
            <Text style={styles.editText}>Edit Menu</Text>
          </TouchableOpacity>
        )}
      </View>
      <View style={styles.contentWrapper}>
        <View style={styles.infoRow}>
          <View style={styles.restaurantInfo}>
            <Text style={styles.restaurantName}>
              {restData.restaurant?.name}
            </Text>
            <View style={styles.cuisineContainer}>
              {restData.restaurant?.cuisines?.map((cuisine, index) => (
                <Text key={index} style={styles.cuisineText}>
                  {cuisine}
                  {index < (restData?.restaurant?.cuisines?.length ?? 0) - 1 &&
                    " • "}
                </Text>
              ))}
            </View>
          </View>
          <RatingInfo ratings={ratings} />
        </View>
      </View>
    </View>
  );
};
